import React from "react";
import styles from "./NewsArticle.module.css";

function NewsArticle(props) {
  return (
    // made the link open in new tab 
    <a href={props.url} target="_blank" rel="noopener noreferrer">
      <div className={styles.newsArticleContainer}>
        <figure className={styles.newsArticleImage}>
          <img src={props.image} alt="news article img"></img>
        </figure>
        <div className={styles.newsArticleInfo}>
          <p className={styles.newsArticleTitle}>
            <h2>{props.title}</h2>
          </p>
          <p className={styles.newsArticleDescription}>{props.description}</p>
          <p className={styles.newsArticleAuthor}>{props.author}</p>
          <p className={styles.newsArticleContent}>{props.content}</p>
        </div>
      </div>
    </a>
  );
}

export default NewsArticle;
